<!-- 特色美食  mjs -->
<template>
  <div class="travelServe delicacyContainer">
    <banner/>
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">特色美食</a>
      </div>
    </div> -->
    <crumbs />
    <div class="container">
      <div class="leftPart pb100 fl">
        <div class="labelBox">
          <type-screen modelType="delicacy" :menu-id="menuId" @typeObj="selectType"/>
        </div>
        <div class="foodList clearfix">
          <div class="foodItem" @click="detaillink(item)" v-for="(item) in delicacyList" :key="item.id">
            <div class="innerbox">
              <img :src="getImage(item.image)"  alt="">
              <!-- <span class="sp" v-if="true">标签</span> -->
              <p class="name">{{item.name}}</p>
              <div class="iconfun">
              <span>
              <star
                class="star"
                starStyle="iconstar1"
                :isSelect="item.isStar"
                :count="item.star"
                :menu-id="menuId"
                :business-id="item.id"
                @changecount="changePraise"
                :title="item.name"
                :image="item.image"
                :url="'/delicacydetail?columnId=' + item.menuId + '&id=' + item.id"
              ></star>
              </span>

                <span><i></i><b>{{item.pv}}</b></span>
              </div>
            </div>
          </div>
        </div>
        <nodata v-show="nodataflag"/>
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="delicacyParam.limit"
          :pager-count="5"
          layout="prev, pager, next"
          :total="total"
          class="pagemodel1">
        </el-pagination>
      </div>
      <div class="rightPart fr">
        <rightBox></rightBox>
      </div>

    </div>
  </div>
</template>

<script>
// import { isLogin } from '@/utils/index'
import nodata from '@/components/nodata/index'
import crumbs from '@/components/crumbs/index'
import star from '@/components/amount/star'
import pv from '@/components/amount/pv'
import {getListAmount} from '@/api/datavolume/index'
import {getdelicacyList} from '@/api/delicacy/index'
import rightBox from '../../components/travelRight/index'
import typeScreen from '@/components/typescreen/index'
import banner from '@/components/banner/index'
export default {
  name: 'delicacy',
  components: {
    rightBox, typeScreen, crumbs, nodata, star, pv, banner
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      delicacyParam: {
        page: 1,
        limit: 12,
        menuId: '6146',
        types: null,
        areaType: null,
        foodType: null
      },
      total: 0,
      menuId: '6146',
      delicacyList: [],
      phoneNum: '',
      nodataflag: false,
      flag: ''
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.delicacyParam.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.getdelicacylist()
  },
  methods: {
    defaultamout (list) {
      list.forEach(item => {
        if (item.collect === undefined) item.collect = 0
        if (item.isCollect === undefined) item.isCollect = 'false'
        if (item.star === undefined) item.star = 0
        if (item.isStar === undefined) item.isStar = 'false'
        if (item.pv === undefined) item.pv = 0
      })
    },
    getdelicacylist () {
      getdelicacyList(this.delicacyParam).then(res => {
        console.log(res, 'mjs')
        // this.delicacyList = res.data.list.data.rows
        this.total = res.data.list.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        // let that = this
        const params = {
          p: this.$cookie.get('wlymobilephone')
        }
        getListAmount(this.menuId, params).then(res1 => {
          console.log(res1, 'res1')

          if (res1.data.data.length !== 0) {
            res1.data.data.forEach(item => {
              res.data.list.data.rows.forEach(val => {
                if (item.dataId === val.id) {
                  val.collect = item.collect
                  val.isCollect = item.isCollect
                  val.pv = item.pv
                  val.isStar = item.isStar
                  val.star = item.star
                }
              })
            })
            this.defaultamout(res.data.list.data.rows)
          } else {
            this.defaultamout(res.data.list.data.rows)
          }
          this.delicacyList = res.data.list.data.rows
        })
      })
    },
    selectType (obj) {
      this.delicacyParam.areaType = obj.areaType
      this.delicacyParam.foodType = obj.foodType
      this.delicacyParam.types = obj.customTypeId
      this.delicacyList = []
      this.getdelicacylist()
    },
    handleCurrentChange (val) {
      this.delicacyParam.page = val
      this.delicacyList = []
      this.getdelicacylist()
    },
    detaillink (val) {
      if (val.link !== undefined && val.link !== '') {
        window.open(val.link)
      } else {
        this.$router.push({path: '/delicacydetail', query: {id: val.id, columnId: this.menuId}})
      }
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    changePraise (val) {
      this.delicacyList.forEach(item => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    }

  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
.star{
  position: relative;
  top: 6px;
}

</style>



// WEBPACK FOOTER //
// src/view/delicacy/list.vue